import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'swapCase'
})
export class SwapCasePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return null;
  }
}
